import ResourceGuide from "@/components/ResourceGuide";

const AgencyBlueprintPage = () => <ResourceGuide slug="agency-blueprint" />;

export default AgencyBlueprintPage;
